import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input,
  Button
} from 'reactstrap'

class FieldText extends Component {
  constructor(props) {
    super(props)

    this.state = {
      charCount: props.cardField.fieldValue ? props.cardField.fieldValue.length : 0,
      fieldType: this.props.cardField.fieldType
    }

    this.returnValue = this.returnValue.bind(this)
    this.countChars = this.countChars.bind(this)
    this.switchPasswordField = this.switchPasswordField.bind(this)
  }

  returnValue() {
    return this[this.props.cardField.id].value
  }

  countChars(ev) {
    if (!this.props.cardField.fieldCharLimit) {
      return
    }

    let charLimit = this.props.cardField.fieldCharLimit
    let charCount = ev.target.value.length

    this.setState({ charCount })
  }

  switchPasswordField() {
    this.setState(prevState => {
      return {
        fieldType: prevState.fieldType === 'password' ? 'text' : 'password'
      }
    })
  }

  render() {
    const fieldClassName = `card-field field-text ${(this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : '')}`

    const lock = this.props.cardField.fieldType === 'password' &&
          <Button type="button" color="link" className="p-0 ml-1" title="Passwort anzeigen" tabIndex="-1">
            <i onClick={this.switchPasswordField} className={`icon-lock${this.state.fieldType === 'password' ? '' : '-open'}`}></i>
          </Button>

    return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
      <Label for={this.props.cardField.id}>
        {this.props.cardField.fieldLabel}
        {lock}
      </Label>
      {this.props.cardField.fieldSublabel && <p className='form-control-sublabel'>{this.props.cardField.fieldSublabel}</p>}
      <InputGroup className={`mb-3${this.props.cardField.fieldCharLimit ? ' has-char-limit' : ''}`}>
        <Input
          type={this.state.fieldType}
          key={this.props.cardField.id}
          id={this.props.cardField.id}
          disabled={!(this.props.isEditing || this.props.cardType === 'always-on')}
          onKeyUp={this.countChars}
          placeholder={this.props.cardField.fieldPlaceholder}
          defaultValue={this.props.cardField.fieldValue}
          maxLength={this.props.cardField.fieldCharLimit}
          required={this.props.cardField.fieldRequired}
          rows={this.props.cardField.textareaRows}
          innerRef={el => { this[this.props.cardField.id] = el }}
        />
        {this.props.cardField.fieldCharLimit ?
          <div className="char-limit-container">
            <span className="char-limit-count">{this.state.charCount}</span>
            <span>/</span>
            <span>{this.props.cardField.fieldCharLimit}</span>
          </div> : null
        }
      </InputGroup>
    </div> : <div className={fieldClassName}>
      <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      <div className="mb-3">{this.props.cardField.fieldValue}</div>
    </div>
  }
}

FieldText.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldText.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldText


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldText.js